import EidSalePricing from "../banner/marketing/EidSalePricing";
import { PriceCard } from "./PriceCard";
import { PriceCardNotAvailable } from "./PriceCard-notavailable,";

export const Price = () => {
  return (
    <div className="container mx-auto px-5 flex flex-col items-center mb-5">
      <p className="text-2xl lg:w-1/2 text-center font-bold">Наши продукты</p>
      <EidSalePricing />

      <div className="flex justify-between gap-6 mt-16 flex-col lg:flex-row">
        <PriceCard
          key={2}
          details={{
            title: "Hydra Flasher",
            header: "Попробуйте наш сервис - Мы субсидируем этот пакет, чтобы вы могли испытать его",
            price: "150",
            offerPrice: "199",
            lifetime: false,
            tier: "Starter - Субсидируемый",
            infos: [
              "Простая настройка",
              "Никаких настроек или скрытых платежей",
              "Дневной лимит 0.001 биткойн",
              "Торговля и трансфертный фонд",
              "Поддержка клиентов: В течение периода",
              "Бесплатные обновления: Нет",
              "1 лицензионный ключ для одного устройства",
            ],
            product_type: "HYDRAFLASHER",
          }}
        />
        <PriceCard
          key={2}
          details={{
            title: "Hydra Flasher Premium",
            header:
              "Лучший вариант для профессионального использования на 6 часов",
            price: "8000",
            lifetime: false,
            tier: "Commercial",
            infos: [
              "Простая настройка",
              "Никаких настроек или скрытых платежей",
              "Дневной лимит 10 биткойн",
              "Торговля и трансфертный фонд",
              "Поддержка клиентов: 6 часов",
              "Бесплатные обновления: В течение периода",
              "1 лицензионный ключ для одного устройства",
            ],
            product_type: "HYDRAFLASHER_PREMIUM",
          }}
        />
        <PriceCard
          key={2}
          details={{
            title: "Hydra Script (API Access)",
            header: "На 1 день",
            price: "15000",
            lifetime: false,
            tier: "Enterprise",
            infos: [
              "Настройка (для Debian Linux и Windows)",
              "Графический интерфейс пользователя (обновлено)",
              "Дневной лимит Flash: «Без ограничений»",
              "Торговля и трансфертный фонд",
              "Бесплатная настройка в первый раз",
              "Бесплатные обновления: В течение периода",
              "Поддержка клиентов: В течение периода",
              "1 лицензионный ключ для одного устройства",
            ],
            product_type: "HYDRAFLASHER_API_ACCESS",
          }}
        />
        <PriceCardNotAvailable
          key={2}
          details={{
            title: "Bullet Proof RDP",
            header: "Лучший вариант для личного пользования на 2 месяца.",
            pricePreffix: "",
            price: "250",
            lifetime: false,
            infos: [
              "Предварительно настроено",
              "Никаких настроек или скрытых платежей",
              "Доступ администратора",
              "Премиум поддержка: 2 месяца",
              "6 ядер 16 ГБ ОЗУ",
              "1 лицензионный ключ для одного устройства",
              "Сервер в Сингапуре",
            ],
            product_type: "BULLET_PRROF_RDP",
          }}
        />
      </div>
    </div>
  );
};
